import { render, staticRenderFns } from "./PosBillSale.vue?vue&type=template&id=1842506a&scoped=true&"
import script from "./PosBillSale.vue?vue&type=script&lang=js&"
export * from "./PosBillSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1842506a",
  null
  
)

export default component.exports